import NotificationContainerView from 'ui/login-bar/mixins/container-view';
import { notificationStatusModel } from 'models/NotificationStatusModel';
import controller from 'ui/login-bar/controller';

const elements = {
  header: '#c-header-ajax-content',
  premiumRedirection: '.user-toolkit-action.uta-redirection',
  container: '.c-notification__settings',
  notificationsList: '.notifications-list',
  loader: '.notifications-loader',
  showMore: '.notifications-more.show-more',
  showOlder: '.notifications-more.show-older',
  noNotificationTrigger: '.notification-none',
};

export default class SystemNotificationContainerView extends NotificationContainerView {
  constructor(model) {
    super(model);
    this.setRootEl($(elements.container));
    notificationStatusModel.addEventListener('systemRefreshed', this.updateTooltip.bind(this));
    model.addEventListener('updated', this.update.bind(this));

    this.initSizes($(elements.container));

    const self = this;
    self.applyResizeEvent($(elements.container));
    $(window).resize(function() {
      self.applyResizeEvent($(elements.container));
    });
  }
  bindScrollEvents() {
    const container = this.rootEl.find(elements.notificationsList);
    const self = this;

    const final = (scrollTop) => {
      setTimeout(() => {
        scrollTop && container.scrollTop(scrollTop);
        container.css('opacity', '1');
        self.bindScrollEvents();
      }, 200);
    };

    container.off('scroll').on('scroll', function() {
      let height = 0;
      $('.notifications-list').find('li').each(function() { height += $(this).outerHeight() });

      if (container.outerHeight() + container.scrollTop() >= (height - 5)) {
        container.off('scroll').css('opacity', '0.5');
        const scrollTop = container.scrollTop();

        controller.loadNewSystemModel().then(function(data) {
          if (data && data.end) {
            container.css('opacity', '1');
            return;
          }
          self.update();
          final(scrollTop);
        }).catch(() => {
          final();
        });
      }
    });
  }
  update() {
    const container = this.rootEl.find(elements.notificationsList);
    const messages = this.model.get('messages');
    this.fillLastLogin();
    container.empty();
    if (messages.length) {
      messages.forEach(this.addMessage.bind(this, 'notification'));
      this.rootEl.find(elements.noNotificationTrigger)
        .addClass('fn-hidden');
    } else {
      this.rootEl.find(elements.noNotificationTrigger)
        .removeClass('fn-hidden');
    }
    this.rootEl.find(elements.loader)
      .addClass('fn-hidden');
  }
  render() {
    const $list = this.rootEl.find(elements.notificationsList);
    if (!$list.length) {
      return;
    }

    this.bulkDockTriggers()
      .on('click', () => {
        setTimeout(() => {
          if (this.collapsed) {
            $list.empty();
            this.rootEl.find(elements.loader).removeClass('fn-hidden');
            controller.updateSystemModel().then((data) => {
              /*
               * For ajax new load
               * - this.bindScrollEvents();
               */
            });
          }
        }, 10);
      });
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/login-bar/system/container-view.js